import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiVimeoService } from '@fi-shared/media-bank/fi-vimeo/fi-vimeo.service';
import { FiVimeoPlayerComponent } from './fi-vimeo-player.component';
import { FiLoadingModule } from '@fi-shared/fi-loading/fi-loading.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FiVimeoDataService } from '@fi-shared/media-bank/fi-vimeo/fi-vimeo-data.service';
import { FiVimeoUnavailableVideoHandlerComponent } from './fi-vimeo-unavailable-video-handler/fi-vimeo-unavailable-video-handler.component';

@NgModule({
    imports: [CommonModule, FiLoadingModule, FiAppTextSharedModule, MatButtonModule, MatIconModule],
    declarations: [FiVimeoPlayerComponent, FiVimeoUnavailableVideoHandlerComponent],
    exports: [FiVimeoPlayerComponent, FiVimeoUnavailableVideoHandlerComponent],
    providers: [FiVimeoService, FiVimeoDataService],
})
export class FiVimeoModule {}
